import React, { Fragment } from "react";

import IMEAltLogo from "../IME/IMEAltLogo";

const ProfileBackgroundPicsTwo = ({
  user,
  profile,
  setShowResume,
  setShowAppliedJobs,
}) => {
  return (
    <Fragment>
      <div className="profile-background-pics">
        <div className="background-image-container">
          {profile.backgroundimagetwo === "alt_logo.png" ? (
            <div className="profile-alt-logo-container">
              <IMEAltLogo />
              <br />
              <br />
              <br />
              <IMEAltLogo />
              <br />
              <br />
              <br />
              <IMEAltLogo />
            </div>
          ) : (
            <img
              className={"profile-background-image"}
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/innovators/${profile.backgroundimagetwo}`}
              alt="background"
            />
          )}
          <div className="profile-user-info">
            {user && user.user !== profile.user && user.role !== "employer" ? (
              <div
                className="profile-user-info-button-green green"
                onClick={() => setShowResume(true)}
              >
                Resume
              </div>
            ) : (
              <div>
                {user.channelid === profile.channelid && (
                  <div
                    className="profile-user-info-button-green green"
                    onClick={() => setShowAppliedJobs(true)}
                  >
                    Applications
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProfileBackgroundPicsTwo;
